import Vue from 'vue';
import _ from "lodash";
import notificationAPI from '../api/notification';

const types = {
    LOADING: 'LOADING',
    LOADING_BY_KEY: 'LOADING_BY_KEY',
    GET_MESSAGES_OK: 'GET_MESSAGES_OK',
    GET_UNREAD_NO: 'GET_UNREAD_NO',
    READ_MESSAGES_OK: 'READ_MESSAGES_OK'
}

const initState = {
    loading: false,
    form: {},
    unreadNo: 10,
    notificationData: {
        "total": 0,
        "items": []
    }
}

const getters = {
    form: state => state.form,
    loading: state => state.loading,
    notificationData: state => state.notificationData,
    unreadNo: state => state.unreadNo
}

const actions = {
    async getMessages({ commit, dispatch }, body) {
        try {
            const { data } = await notificationAPI(dispatch).getMessages(body);
            commit(types.GET_MESSAGES_OK, data);
        } catch (e) {
            Vue.$log.error("Failed to get the notifications", e);
        }
    },
    async getUnreadNo({ commit, dispatch }, body) {
        try {
            const { data } = await notificationAPI(dispatch).getUnreadNo();
            commit(types.GET_UNREAD_NO, data);
        } catch (e) {
            Vue.$log.error("Failed to get unread no of messages", e);
        }
    },
}

const mutations = {
    [types.LOADING](state, loading) {
        Vue.set(state, 'loading', loading);
    },
    [types.LOADING_BY_KEY](state, data) {
        Vue.set(state.form, data.key, data.status);
    },
    [types.GET_MESSAGES_OK](state, data) {
        Vue.set(state.notificationData, 'total', data.total);
        Vue.set(state.notificationData, 'items', data.items);
    },
    [types.GET_UNREAD_NO](state, data) {
        Vue.set(state, 'unreadNo', data);
    }
}

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations
};